<style scoped>
  .btn-text:active {
    color: #2b85e4 !important;
  }
  .end-comment {
    position: absolute;
    width:100%;
  }
  .end-comment img {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
</style>

<template>
  <app-layout style="margin: 16px">
    <!-- <div class='end-comment' display="flex">
      <img alt=" " src="@/assets/end-comment.png" width="80px" height="40px" style="margin-top:-5px">
    </div> -->
    <!-- <video-player
      class="video-js"
      :options="{
        poster: require('@/assets/sharpen-warrior-logo-large.jpg'),
        sources: [{
          src: 'https://s3.amazonaws.com/sharpenminds/videos/2019.1.7+Craig+and+Charlie+Intros+draft+2.mp4'
        }]
      }"
    /> -->
    <p style="text-align:center;font-size: 3vh;line-height: 1.5;margin:16px 0">
      Are you ready to learn and engage. You are free to register completely anonymously, but you must agree to treat everyone you find here civilly.
    </p>
    <div display="flex" style="padding:10px;margin-top:45px">
      <router-link to="/step3?type=mobile">
        <Button type="primary" style="float:right">Next</Button>
      </router-link>
      <router-link class="btn-text" style="float:right;padding:6px 15px;color:#495060" to="/home">
        <span>Not Yet</span>
      </router-link>
    </div>
  </app-layout>
</template>

<script>
  export default {
    name: "StepOneMobileComponent",
    data() {
      return {};
    }
  };
</script>